var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',{staticClass:"text-3xl text-center mb-10"},[_vm._v("\n    "+_vm._s(_vm.fields.title)+"\n  ")]),_vm._v(" "),_c('ProductCarousel',{attrs:{"default-options":_vm.defaultOptions}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }